import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useGDLData } from './useGDLData';

const API = process.env.REACT_APP_BACKEND_URL || '';
const CATS = {
  Airtime: ['MTN', 'Airtel', 'Glo', '9mobile'],
  'Data Bundles': ['MTN', 'Airtel', 'Glo', '9mobile'],
  Electricity: ['EKEDC', 'IKEDC', 'AEDC', 'PHED'],
  'Cable TV': ['DSTV', 'GOtv', 'Startimes'],
};

export default function GDLBills() {
  const nav = useNavigate();
  const { billsHistory, csId, refresh } = useGDLData();
  const [cat, setCat] = useState('Airtime');
  const [prov, setProv] = useState('MTN');
  const [ident, setIdent] = useState('');
  const [amt, setAmt] = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  useEffect(() => { setProv(CATS[cat]?.[0] || ''); }, [cat]);
  if (!csId) { nav('/demo/gdl/login'); return null; }

  const pay = async () => {
    setLoading(true); setResult(null);
    try {
      const { data } = await axios.post(`${API}/api/demo/gdl/bills/${csId}`, {
        category: cat, provider: prov, identifier: ident, amount: parseFloat(amt),
      }, { withCredentials: true });
      setResult(data); setAmt(''); refresh();
    } catch (e) { setResult({ error: e.response?.data?.detail || 'Failed' }); }
    setLoading(false);
  };

  return (
    <div style={{ padding: '12px 16px 24px', display: 'flex', flexDirection: 'column', gap: 18 }}>
      <div>
        <div style={{ fontSize: 20, fontWeight: 700, color: '#2D0A10', letterSpacing: '-0.02em' }}>Pay Bills</div>
        <div style={{ fontSize: 14, color: '#A07078', marginTop: 2 }}>Airtime, data, power & cable TV</div>
      </div>

      <div style={{ background: '#fff', borderRadius: 20, padding: 20, boxShadow: '0 2px 12px rgba(176,49,64,0.06)' }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 18 }}>
          {Object.keys(CATS).map(c => (
            <button key={c} onClick={() => setCat(c)} data-testid={`bill-cat-${c}`}
              style={{
                padding: 12, borderRadius: 14, cursor: 'pointer', textAlign: 'center',
                border: cat === c ? '2px solid #B03140' : 'none',
                background: cat === c ? 'rgba(176,49,64,0.04)' : 'rgba(176,49,64,0.03)',
                fontWeight: 700, fontSize: 13, color: cat === c ? '#B03140' : '#A07078',
                transition: 'all 0.15s ease',
              }}>
              {c}
            </button>
          ))}
        </div>

        <label style={lbl}>Provider</label>
        <select value={prov} onChange={e => setProv(e.target.value)} style={inp} data-testid="bill-provider">
          {(CATS[cat] || []).map(p => <option key={p}>{p}</option>)}
        </select>

        <label style={{ ...lbl, marginTop: 16 }}>
          {cat === 'Electricity' ? 'Meter Number' : cat === 'Cable TV' ? 'Smartcard Number' : 'Phone Number'}
        </label>
        <input value={ident} onChange={e => setIdent(e.target.value)} style={inp} data-testid="bill-identifier" />

        <label style={{ ...lbl, marginTop: 16 }}>Amount ({'\u20A6'})</label>
        <input type="number" value={amt} onChange={e => setAmt(e.target.value)} style={inp} placeholder="0.00" data-testid="bill-amount" />

        <button onClick={pay} disabled={loading || !ident || !amt} data-testid="bill-pay-btn"
          style={{ ...btnP, marginTop: 20, opacity: (loading || !ident || !amt) ? 0.5 : 1 }}>
          {loading ? 'Processing...' : `Pay ${cat}`}
        </button>

        {result?.reference && (
          <div style={{ background: '#ECFDF5', borderRadius: 12, padding: 14, marginTop: 14, textAlign: 'center' }} data-testid="bill-success">
            <div style={{ fontWeight: 700, color: '#059669' }}>Payment Successful</div>
            <div style={{ fontSize: 13, color: '#A07078', marginTop: 4 }}>Ref: {result.reference}</div>
          </div>
        )}
        {result?.error && <div style={{ color: '#EF4444', fontSize: 13, fontWeight: 600, marginTop: 8 }}>{result.error}</div>}
      </div>

      {(billsHistory || []).length > 0 && (
        <div>
          <div style={{ fontSize: 15, fontWeight: 700, color: '#2D0A10', marginBottom: 10 }}>Recent Payments</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
            {billsHistory.slice(0, 5).map(b => (
              <div key={b.id} style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                padding: '12px 16px', background: '#fff', borderRadius: 16,
                boxShadow: '0 1px 6px rgba(176,49,64,0.04)',
              }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 700, color: '#2D0A10' }}>{b.provider}</div>
                  <div style={{ fontSize: 12, color: '#A07078' }}>{b.identifier}</div>
                </div>
                <div style={{ fontSize: 14, fontWeight: 700, color: '#2D0A10' }}>{'\u20A6'}{b.amount.toLocaleString()}</div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

const lbl = { display: 'block', fontSize: 12, fontWeight: 600, color: '#8E2233', marginBottom: 6, textTransform: 'uppercase', letterSpacing: '0.04em' };
const inp = { width: '100%', padding: '14px 16px', border: '1.5px solid rgba(176,49,64,0.12)', borderRadius: 12, fontSize: 15, outline: 'none', boxSizing: 'border-box', background: 'rgba(176,49,64,0.03)', color: '#2D0A10' };
const btnP = { width: '100%', padding: '15px', background: '#B03140', color: '#fff', border: 'none', borderRadius: 14, fontSize: 15, fontWeight: 600, cursor: 'pointer', boxShadow: '0 4px 16px rgba(176,49,64,0.2)' };
